// PageUser Component

/* eslint react/jsx-indent: 0,
  indent: 0,
  standard/no-callback-literal: 0,
  handle-callback-err: 0 */

import React from 'react'
import async from 'async'
import _ from 'lodash'

import app from '../../../app.jsx'
import TagUtil from '../../../lib/tagutil.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Button from '../../../common/common/button/button.jsx'
import List from '../../../../components/List/List.jsx'
import Grid from '../../../common/common/grid/grid.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import UserItem from '../../../common/user/user_item/user_item.jsx'
import DialogSetting from '../../../contact/dialog/dialog_setting/dialog_setting.jsx'
import UserForm from '../../../common/form/user_form/user_form.jsx'
import ScheduleOptionUtil from '../../../lib/scheduleoptionutil.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import currency from '../../../lib/currency.jsx'
import DialogSchedule from '../../../common/dialog/dialog_schedule/dialog_schedule.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import BaseSettings from '../../page/base_setting/base_setting.jsx'
import { upsertUserInStream, updateStreamUserActivated } from '../../../common/page/page_chat/utils.js'
import { USER_STATUS_ACTIVE, USER_STATUS_ARCHIVED, USER_STATUS_INVITED } from '../../../lib/constants.js'

class PageUser extends BaseSettings {
  constructor (props) {
    super(props, 'setting-user', 'setting-user', 'usersetting')

    this.state = {
      isLoading: true,
      dataDate: null,
      type: 'grid',
      pageNo: 1,
      sort: 'firstName',
      sortAsc: true
    }

    this.data = {
      users: [],
      total: 0,
      countLoaded: 0,
      canPaginate: true,
      sort: 'firstName',
      sortAsc: true,
      pageNo: 1,
      filter: null,
      curUser: null,
      showSettings: false,
      teamId: app.getTeamId(),
      skillSuggestions: [],
      scheduleOption: null
    }

    this._references = {
      refDialogSchedule: React.createRef(),
      userSettingDialog: React.createRef(),
      confirmDelete: React.createRef(),
      userform: React.createRef(),
      scheduleSettingDialog: React.createRef(),
      scheduleConfirmDelete: React.createRef()
    }
    this._bUnMounted = false
    this._setFABButtonState(true, false)
  }

  componentDidMount () {
    this._getData()
    this._initEvents()
    this._triggerAdd()
  }

  componentWillUnmount () {
    this._bUnMounted = true
    this._releaseEvents()
  }

  componentDidUpdate () {
    this._triggerSettingsDialog()
  }

  renderContent () {
    return (
      <div className='pageinnercont'>
        {this._renderMessage()}
        {this._renderGridOrList()}
        {this._renderSettingsDialog()}
        {this._renderUserForm()}
        {this._renderScheduleSettingsDialog()}
        <DialogSchedule
          ref={this._references.refDialogSchedule}
          defaultSchedule={ScheduleOptionUtil.getDefaultScheduleOption()}
          onCreate={this._onCreateSchedule.bind(this)}
          onEdit={this._onEditSchedule.bind(this)}
        />
      </div>
    )
  }

  getContentClassname () {
    return this.state.type === 'grid' ? 'alt' : null
  }

  /* Event Handlers */
  _onCreateSchedule (createData) {
    if (this.data.curUser) {
      createData.id = `schedule-${this.data.curUser.lastScheduleIndex++}`

      this.data.curUser.scheduleOptions.push(createData)

      if (this._references.refDialogSchedule.current) {
        this._references.refDialogSchedule.current.hide()
      }

      if (this._references.userform.current) {
        this._references.userform.current.refreshSchedules(
          this.data.curUser.scheduleOptions
        )
      }
    }
  }

  _onEditSchedule (scheduleId, updateData) {
    if (this.data.curUser) {
      this.data.curUser.scheduleOptions.map(obj => {
        if (obj.id === scheduleId) {
          obj.fromDate = updateData.fromDate
          obj.toDate = updateData.toDate
          obj.schedules = updateData.schedules
        }
      })

      if (this._references.refDialogSchedule.current) {
        this._references.refDialogSchedule.current.hide()
      }

      if (this._references.userform.current) {
        this._references.userform.current.refreshSchedules(
          this.data.curUser.scheduleOptions
        )
      }
    }
  }

  _onChangePage (pageIdent) {
    app.changePage(pageIdent)
  }

  _onFilter (filter) {
    this.data.filter = filter

    if (filter.contentType !== this.state.type) {
      this.setState({ type: filter.contentType })
    } else {
      this.data.pageNo = 1
      this._reloadData()
    }
  }

  _onGridItemClick (user) {
    if (!app.isDemo) {
      if (user && user.id && user.userId) {
        ScheduleOptionUtil.getUserScheduleOptions(
          user.userId,
          (err, userScheduleOptions) => {
            user.scheduleOptions = userScheduleOptions
            user.removeScheduleIds = []
            this._onClickUserEdit(user, null)
          }
        )
      }
    } else {
      this.showError('setting.userList.errorDemoMsg')
    }
  }

  _onCloseSetting () {
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.hide()
    }
  }

  _onCloseScheduleSetting () {
    this._setFABButtonVisible(false)

    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.hide()
    }
  }

  _onGridItemSettingClick (user, e) {
    e.preventDefault()

    if (!app.isDemo) {
      ScheduleOptionUtil.getUserScheduleOptions(
        user.userId,
        (err, userScheduleOptions) => {
          user.scheduleOptions = userScheduleOptions
          this.data.curUser = user
          this.data.showSettings = true

          this.setState({ dataDate: new Date() })
        }
      )
    } else {
      this.showError('setting.userList.errorDemoMsg')
    }
  }

  _triggerSettingsDialog () {
    if (this.data.showSettings) {
      this.data.showSettings = false

      if (this.data.curUser) {
        const user = this.data.curUser

        if (this._references.userSettingDialog.current) {
          this._references.userSettingDialog.current.show(
            `${user.firstName} ${user.lastName}`,
            user.functions,
            null,
            null
          )
        }
      }
    }
  }

  _onClickUserEdit (user, e) {
    if (e) {
      e.preventDefault()
    }

    if (user && user.id) {
      this.data.curUser = user
      this.data.curUser.lastScheduleIndex = 0

      this._getTeamAccountOwnerDetails(user)

      if (this._references.userSettingDialog.current) {
        if (this._references.confirmDelete.current) {
          this._references.confirmDelete.current.hide()
        }
        if (this._references.userSettingDialog.current) {
          this._references.userSettingDialog.current.hide()
        }
      }
    }
  }

  _onClickArchive (e) {
    e.preventDefault()

    const params = {
      query: {
        $client: {
          statTeamId: {
            id: this.data.teamId
          },
          workflowTeamId: {
            id: this.data.teamId
          }
        }
      }
    }
    const { id } = this.data.curUser
    app
      .service('/api/users/team')
      .patch(id, { status: USER_STATUS_ARCHIVED }, params)
      .then(async (user) => {
        this.data.curUser = null

        await updateStreamUserActivated(user.userId, false)

        if (this._references.confirmDelete.current) {
          this._references.confirmDelete.current.hide()
        }

        if (this._references.userSettingDialog.current) {
          this._references.userSettingDialog.current.hide()
        }
        this._reloadData()
      })
      .catch(arcErr => {
        app.debug('Page users archive err', arcErr)
      })
  }

  _onClickUnArchive (e) {
    e.preventDefault()

    const params = {
      query: {
        $client: {
          statTeamId: {
            id: this.data.teamId
          },
          workflowTeamId: {
            id: this.data.teamId
          }
        }
      }
    }

    const { id, inviteToken } = this.data.curUser
    const updateObj = {
      status: inviteToken ? USER_STATUS_INVITED : USER_STATUS_ACTIVE
    }

    app
      .service('/api/users/team')
      .patch(id, updateObj, params)
      .then(async (user) => {
        this.data.curUser = null
        await updateStreamUserActivated(user.userId, true)

        if (this._references.confirmDelete.current) {
          this._references.confirmDelete.current.hide()
        }

        if (this._references.userSettingDialog.current) {
          this._references.userSettingDialog.current.hide()
        }
        this._reloadData()
      })
      .catch(arcErr => {
        app.debug('Page users unarchive err', arcErr)
      })
  }

  _onClickResend (e) {
    e.preventDefault()
    const createObj = {
      userTeamId: this.data.curUser.id,
      teamId: this.data.teamId,
      bResend: true
    }

    app
      .service('/api/user/invite')
      .create(createObj)
      .then(_inviteRes => {
        this.data.curUser = null

        if (this._references.confirmDelete.current) {
          this._references.confirmDelete.current.hide()
        }

        if (this._references.userSettingDialog.current) {
          this._references.userSettingDialog.current.hide()
        }
      })
      .catch(inviteErr => {
        app.debug('Page users invite err', inviteErr)
      })
  }

  _onClickDeleteInviteUser (e) {
    e.preventDefault()

    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.show()
    }
  }

  _onClickInviteDeleteConfirm (userTeam, _e) {
    const { id } = userTeam
    app
      .service('/api/users/team')
      .remove(id)
      .then(() => {
        if (this._references.confirmDelete.current) {
          this._references.confirmDelete.current.hide()
        }

        if (this._references.userSettingDialog.current) {
          this._references.userSettingDialog.current.hide()
        }
        this._reloadData()
      })
      .catch(deleteErr => {
        app.debug('Page User delete err', deleteErr)
      })
  }

  /* Private Functions */
  _renderMessage () {
    if (!this.state.isLoading && !this.data?.users?.length) {
      const filter = this.data.filter

      if (filter && filter.filterType === 'archieve') {
        return (
          <ContentMessage
            message='setting.userForm.msgNoUsersArchivedTitle'
            info='setting.userForm.msgNoUsersArchivedInfo'
          />
        )
      }

      return (
        <ContentMessage
          message='setting.userForm.msgNoUsersAddedTitle'
          info='setting.userForm.msgNoUsersAddedInfo'
          showAddPrefix
          showAdd
          onAdd={this.onAdd.bind(this)}
        />
      )
    }

    return ''
  }

  _renderGridOrList () {
    let bShowLoader = false
    if (this.data.users && this.data.users.length < this.data.total) {
      bShowLoader = true
    }

    if (this.state.type === 'list') {
      return (
        <div className='listwrap'>
          <List
            objectList={this.data.users}
            sortOptions={this._getSortOptions()}
            columns={this._getListCloumns()}
            onPaginate={this._onPaginate.bind(this)}
            onSort={this._onSort.bind(this)}
            renderCustomCell={this._onRenderList.bind(this)}
            onView={this._onGridItemClick.bind(this)}
            sort={this.data.sort}
            sortAsc={this.data.sortAsc}
            showLoader={bShowLoader}
          />
        </div>
      )
    }
    return (
      <div className='gridwrap'>
        <Grid
          objectList={this.data.users}
          sortOptions={this._getSortOptions()}
          onPaginate={this._onPaginate.bind(this)}
          sortAsc={this.data.sortAsc}
          showLoader={bShowLoader}
          onSort={this._onSort.bind(this)}
          onRenderGrid={this._onRenderGrid.bind(this)}
        />
      </div>
    )
  }

  _renderSettingsDialog () {
    const { isLoading } = this.state
    const user = this.data.curUser

    if (isLoading || !user) {
      return null
    }

    const bInvited = user.status && user.status === 'invited'

    return (
      <DialogSetting ref={this._references.userSettingDialog}>
        <div className='actionboard-row act-row'>
          <div className='actionboard-col2 alert-col2'>
            <div
              className='action-btn'
              onClick={this._onClickUserEdit.bind(this, user)}
            >
              <Button
                icon='action-edit'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='setting.userList.actionEdit' />
              </span>
            </div>
          </div>
          {(user.status === 'active' || bInvited) &&
            user.userId &&
            user.userId !== app.loggedInId && (
              <div className='actionboard-col2 alert-col2'>
                <div
                  className='action-btn'
                  onClick={this._onClickArchive.bind(this)}
                >
                  <Button
                    icon='action-archive'
                    className='button_dialog'
                    canHover={false}
                  />
                  <span className='label'>
                    <IntlMessage ident='setting.userList.actionArchive' />
                  </span>
                </div>
              </div>
            )}
          {user.status === 'archived' && (
            <div className='actionboard-col2 alert-col2'>
              <div
                className='action-btn'
                onClick={this._onClickUnArchive.bind(this)}
              >
                <Button
                  icon='action-unarchive'
                  className='button_dialog'
                  canHover={false}
                />
                <span className='label'>
                  <IntlMessage ident='setting.userList.actionUnarchive' />
                </span>
              </div>
            </div>
          )}
        </div>
        {(user.inviteToken || bInvited) && (
          <div className='actionboard-row act-row'>
            {bInvited && (
              <div className='actionboard-col2 alert-col2'>
                <div
                  className='action-btn'
                  onClick={this._onClickResend.bind(this)}
                >
                  <Button
                    icon='action-retry'
                    className='button_dialog'
                    canHover={false}
                  />
                  <span className='label'>
                    <IntlMessage ident='setting.userList.actionResendInvite' />
                  </span>
                </div>
              </div>
            )}
            {user.inviteToken && (
              <div className='actionboard-col2 alert-col2'>
                <div
                  className='action-btn'
                  onClick={this._onClickDeleteInviteUser.bind(this)}
                >
                  <Button
                    icon='action-delete'
                    className='button_dialog button_dialogdlt'
                    canHover={false}
                  />
                  <span className='label'>
                    <IntlMessage ident='setting.userList.actionDeleteInvite' />
                  </span>
                </div>
              </div>
            )}
          </div>
        )}
        <ConfirmDelete
          ref={this._references.confirmDelete}
          title='setting.userList.msgConfirmDelete'
          onClickOk={this._onClickInviteDeleteConfirm.bind(this, user)}
        />
      </DialogSetting>
    )
  }

  _triggerAdd () {
    if (this.props.showadd) {
      this.onAdd()
    }
  }

  _getData () {
    async.series(
      [
        done => {
          this._getPageData(done)
        },
        done => {
          this._getDataUsers(done)
        },
        done => {
          TagUtil.getSkillTags(skills => {
            this.data.skillSuggestions = skills
            done(null)
          })
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _getDataUsers (callback) {
    app.debug('PageUser: _getDataUsers [start]')
    const sort = this.data.sort
    const sortAsc = this.data.sortAsc ? 1 : -1
    const skip = (this.data.pageNo - 1) * 20
    const params = {
      query: {
        $limit: 20,
        $skip: skip,
        $sort: {}
      }
    }
    params.query.teamId = this.data.teamId
    params.query.$sort[sort] = sortAsc

    const ACTIVE_QUERY = { $in: ['active', 'invited'] }

    // Process Filters
    const filter = this.data.filter
    if (filter) {
      if (filter.filterType === 'active') {
        params.query.status = ACTIVE_QUERY
      } else if (filter.filterType === 'archieve') {
        params.query.status = 'archived'
      }
    } else {
      params.query.status = ACTIVE_QUERY
    }

    app
      .service('/api/users/team')
      .find(params)
      .then(result => {
        this.data.users =
          this.data.pageNo > 1
            ? this.data.users.concat(result.data)
            : result.data

        this.data.total = result.total
        this.data.countLoaded = params.query.$limit * this.data.pageNo
        this.data.canPaginate = !(this.data.countLoaded > this.data.total)
        callback(null)
      })
      .catch(err => {
        app.debug('PageUser: _getDataUsers err', err)
        callback(err)
      })
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageUser: _onDataReceived Error', err)
      this._setFABButtonVisible(false)
      this.setState({ isLoading: true, dataDate: new Date() })
    } else {
      app.debug('PageUser: _onDataReceived [done]')

      if (this.data.users && this.data.users.length > 0) {
        this._setFABButtonVisible(true)
      } else {
        this._setFABButtonVisible(false)
      }

      this.setState({
        isLoading: !this.data.users,
        dataDate: new Date()
      })
    }
  }

  _getListCloumns () {
    return [
      {
        label: 'setting.userList.labelFirstName',
        identifier: 'firstName',
        width: '20%',
        sort: true,
        filterType: 'autocomplete',
        type: 'text'
      },
      {
        label: 'setting.userList.labelLastName',
        identifier: 'lastName',
        width: '20%',
        sort: true,
        filterType: 'autocomplete',
        type: 'text'
      },
      {
        label: 'setting.userList.labelEmail',
        identifier: 'email',
        width: '20%',
        sort: true,
        filterType: 'autocomplete',
        type: 'text'
      },
      {
        label: 'setting.userList.labelFunction',
        identifier: 'functions',
        width: '20%',
        sort: true,
        filterType: 'autocomplete',
        type: 'text'
      },
      {
        label: 'setting.userList.labelUserType',
        identifier: 'roleType',
        width: '20%',
        sort: true,
        filterType: 'autocomplete',
        type: 'text'
      }
    ]
  }

  _getSortOptions () {
    return [
      { label: 'setting.userList.labelFirstName', value: 'firstName' },
      { label: 'setting.userList.labelLastName', value: 'lastName' },
      { label: 'setting.userList.labelEmail', value: 'email' },
      { label: 'setting.userList.labelFunction', value: 'functions' },
      { label: 'setting.userList.labelUserType', value: 'roleType' }
    ]
  }

  _onPaginate () {
    if (this.data.canPaginate) {
      const page = this.data.pageNo + 1
      this.data.pageNo = page
      this._reloadData()
    }
  }

  _onSort (sort, sortAsc) {
    this.data.sort = sort
    this.data.sortAsc = sortAsc
    this.data.pageNo = 1
    this._reloadData()
  }

  _onRenderList (user, column, idx) {
    return <div key={idx} />
  }

  _onRenderGrid (user) {
    return (
      <UserItem
        user={user}
        key={user.id}
        onView={this._onGridItemClick.bind(this, user)}
        onSettings={this._onGridItemSettingClick.bind(this, user)}
      />
    )
  }

  _reloadData () {
    this._getData()
  }

  onAdd () {
    if (!app.isDemo) {
      this.data.curUser = {
        email: '',
        firstName: '',
        functions: '',
        lastName: '',
        language: this._getTeamDefaultLanguage(),
        rateCards: [],
        skills: [],
        status: 'invited',
        lastScheduleIndex: 0,
        removeScheduleIds: [],
        scheduleOptions: []
      }

      if (this._references.userform.current) {
        this._references.userform.current.show(
          null,
          false,
          ScheduleOptionUtil.getDefaultScheduleOption()
        )
      }
    } else {
      this.showError('setting.userList.errorDemoMsg')
    }
  }

  _getTeamAccountOwnerDetails (user) {
    const userParams = {
      query: {
        teamId: app.getTeamId(),
        roles: 'Account owner',
        _id: { $nin: [user.id] }
      }
    }

    app
      .service('/api/users/team')
      .find(userParams)
      .then(findRes => {
        if (this._references.userform.current) {
          this._references.userform.current.show(
            user,
            findRes.data.length <= 0,
            user.scheduleOptions
          )
        }
      })
      .catch(_err => {
        if (this._references.userform.current) {
          this._references.userform.current.show(
            user,
            true,
            user.scheduleOptions
          )
        }
      })
  }

  _onSubmitUser (
    userInfo,
    userTeamId,
    userId,
    roleType,
    roles,
    userSchedules,
    userScheduleOptions,
    timezone
  ) {
    if (userTeamId) {
      this._updateUserTeam(
        userInfo,
        userTeamId,
        userId,
        roleType,
        roles,
        userSchedules,
        userScheduleOptions,
        timezone
      )
    } else {
      this._createUserTeam(
        userInfo,
        roleType,
        roles,
        userSchedules,
        userScheduleOptions,
        timezone
      )
    }
  }

  _createUserTeam (
    userInfo,
    roleType,
    roles,
    schedules,
    scheduleOptions,
    timezone
  ) {
    let existUserId = null
    const email = userInfo.email.trim().toLowerCase()
    const teamId = app.getTeamId()

    async.series(
      [
        done => {
          const userTeamParams = {
            query: { email, teamId }
          }

          app
            .service('/api/users/team')
            .find(userTeamParams)
            .then(userTeamRes => {
              if (userTeamRes && userTeamRes.data.length > 0) {
                done(new Error('User Already Exists'))
              } else {
                done(null)
              }
            })
            .catch(err => {
              done(err)
            })
        },
        done => {
          // Verify whether user is already signed up or not
          const findParams = { query: { email: email } }
          app
            .service('/api/users')
            .find(findParams)
            .then(userRes => {
              if (userRes.data && userRes.data.length > 0) {
                existUserId = userRes.data[0].id
              }

              done(null)
            })
            .catch(err => {
              done(err)
            })
        },
        done => {
          if (!existUserId) {
            const createData = {
              email: email
            }

            app
              .service('/api/users')
              .create(createData)
              .then(userRes => {
                existUserId = userRes.id
                done(null)
              })
              .catch(userErr => {
                done(userErr)
              })
          } else {
            done(null)
          }
        },
        done => {
          this._invite(existUserId, userInfo, roleType, roles, done)
        },
        done => {
          ScheduleOptionUtil.updateUserScheduleOptions(
            existUserId,
            schedules,
            scheduleOptions,
            timezone,
            done
          )
        },
        done => {
          if (
            this.data.curUser &&
            this.data.curUser.removeScheduleIds &&
            this.data.curUser.removeScheduleIds.length > 0
          ) {
            ScheduleOptionUtil.removeUserScheduleOptions(
              this.data.curUser.removeScheduleIds,
              done
            )
          } else {
            done(null)
          }
        }
      ],
      (err, _res) => {
        if (err) {
          app.debug('### PageUser - _createUser - Error', err)
          if (err.message) {
            this.showError('setting.userList.createUserErrorExistsMsg')
          } else {
            this.showError('setting.userList.createUserErrorMsg')
          }
        } else {
          this.data.curUser = null

          if (this._references.userform.current) {
            this._references.userform.current.hide()
          }
          this._reloadData()
        }
      }
    )
  }

  _invite (existUserId, createObj, roleType, roles, callback) {
    const createData = {
      userId: existUserId,
      teamId: this.data.teamId,
      email: createObj.email,
      status: 'invited',
      roleType: roleType,
      roles: roles,
      firstName: createObj.firstName,
      lastName: createObj.lastName,
      language: createObj.language,
      functions: createObj.functions,
      rateCards: createObj.rateCards,
      skills: createObj.skills,
      timezone:
        app.getTeam() &&
        app.getTeam().profile &&
        app.getTeam().profile.country &&
        this._getTimezone(app.getTeam().profile.country)
    }

    const params = {
      query: {
        $client: {
          sendInvite: {
            value: true
          }
        }
      }
    }

    app
      .service('/api/users/team')
      .create(createData, params)
      .then(_res => {
        callback(null)
      })
      .catch(err => {
        app.debug(err)
        callback(err)
      })
  }

  _updateUserTeam (
    userInfo,
    userTeamId,
    userId,
    roleType,
    roles,
    schedules,
    scheduleOptions,
    timezone
  ) {
    async.series(
      [
        done => {
          const updateData = {
            // email: createObj.email, TODO: IF email is updated,resendconfirm?
            roleType: roleType,
            roles: roles,
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            language: userInfo.language,
            functions: userInfo.functions,
            rateCards: userInfo.rateCards,
            skills: userInfo.skills
          }

          this._update(userTeamId, updateData, done)
        },
        done => {
          ScheduleOptionUtil.updateUserScheduleOptions(
            userId,
            schedules,
            scheduleOptions,
            timezone,
            done
          )
        },
        done => {
          if (
            this.data.curUser.removeScheduleIds &&
            this.data.curUser.removeScheduleIds.length > 0
          ) {
            ScheduleOptionUtil.removeUserScheduleOptions(
              this.data.curUser.removeScheduleIds,
              done
            )
          } else {
            done(null)
          }
        },
        (done) => {
          upsertUserInStream({
            userId,
            roles,
            firstName: userInfo?.firstName,
            lastName: userInfo?.lastName
          }, app.getTeamId(), done)
        }
      ],
      (err, _res) => {
        if (err) {
          app.debug('### PageUser - _updateUser - Error', err)
          if (err.message === 'Account owner is required') {
            this.showError('setting.userList.ownerRequiredError')
          } else {
            this.showError('setting.userList.updateUserErrorMsg')
          }
        } else {
          this.data.curUser = null

          if (this._references.userform.current) {
            this._references.userform.current.hide()
          }
          this._reloadData()
        }
      }
    )
  }

  _update (userTeamId, updateObj, callback) {
    const params = {
      query: {
        $client: {
          validateTeamId: {
            id: this.data.teamId
          },
          statTeamId: {
            id: this.data.teamId
          },
          workflowTeamId: {
            id: this.data.teamId
          },
          skillTeamId: {
            id: this.data.teamId,
            invite: false
          }
        }
      }
    }

    app
      .service('/api/users/team')
      .patch(userTeamId, updateObj, params)
      .then(userRes => {
        if (userRes.userId === app.loggedInId) {
          app.setLanguage(userRes.language)
          app.teamContext.setActiveUserTeam(userRes)

          if (userRes && userRes.roles && userRes.roles.length > 0) {
            const accOwner = _.find(
              userRes.roles,
              role => role === 'Account owner'
            )
            if (!accOwner) {
              this._onChangePage('dashboard')
            }
          }
        }
        callback(null)
      })
      .catch(userErr => {
        callback(userErr)
      })
  }

  _validateRole (userId, callback) {
    if (userId) {
      callback(true)
    } else {
      callback(true)
    }
  }

  _onCloseForm () {
    this.data.curUser = null

    if (this._references.userform.current) {
      this._references.userform.current.hide()
    }

    if (this.data.users && this.data.users.length > 0) {
      this._setFABButtonVisible(true)
      this.setState({ dataDate: new Date() })
    }
  }

  _onShowError (msgIdent) {
    this.showError(msgIdent)
  }

  /* Private functions */
  _renderUserForm () {
    const showLanguageDropdown = !(
      app.teamCountry === 'US' || app.teamCountry === 'UK'
    )

    return (
      <UserForm
        ref={this._references.userform}
        validateRole={this._validateRole.bind(this)}
        prefixCurrency={currency.symbol()}
        onSubmit={this._onSubmitUser.bind(this)}
        onClose={this._onCloseForm.bind(this)}
        skillSuggestions={this.data.skillSuggestions}
        defaultLang={this._getTeamDefaultLanguage()}
        showLanguageDropdown={showLanguageDropdown}
        onAddSchedule={this._onAddSchedule.bind(this)}
        onClickSetting={this._onClickSetting.bind(this)}
        onShowError={this._onShowError.bind(this)}
      />
    )
  }

  _renderScheduleSettingsDialog () {
    const scheduleOption = this.data.scheduleOption

    return (
      <DialogSetting
        ref={this._references.scheduleSettingDialog}
        onClose={this._onCloseScheduleSetting.bind(this)}
        className='alt'
      >
        <div className='actionboard-row act-row'>
          <div className='actionboard-col2 alert-col2'>
            <div
              className='action-btn'
              onClick={this._onClickEditSchedule.bind(this, scheduleOption)}
            >
              <Button
                icon='action-edit'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='estimate.view.editText' />
              </span>
            </div>
          </div>
          <div className='actionboard-col2 alert-col2'>
            <div
              className='action-btn'
              onClick={this._onClickDeleteSchedule.bind(this)}
            >
              <Button
                icon='action-delete'
                className='button_dialog button_dialogdlt'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='estimate.view.deleteText' />
              </span>
            </div>
          </div>
        </div>
        <ConfirmDelete
          ref={this._references.scheduleConfirmDelete}
          title='estimate.view.confirmTitle'
          onClickOk={this._onClickScheduleDeleteConfirm.bind(this)}
        />
      </DialogSetting>
    )
  }

  _onAddSchedule (scheduleOptions) {
    let scheduleWithoutToDate = null
    scheduleOptions.forEach(scheduleOpt => {
      if (!scheduleOpt.toDate) {
        scheduleWithoutToDate = scheduleOpt
      }
    })

    if (scheduleWithoutToDate) {
      const previousSchedulePeriods = ScheduleOptionUtil.getAllSchedulePeriods(
        scheduleOptions,
        scheduleWithoutToDate.id
      )
      const schedule = ScheduleOptionUtil.getRenderScheduleObject(
        scheduleWithoutToDate
      )

      if (this._references.refDialogSchedule.current) {
        this._references.refDialogSchedule.current.showForEndDate(
          schedule,
          previousSchedulePeriods
        )
      }
    } else {
      const previousSchedulePeriods = ScheduleOptionUtil.getAllSchedulePeriods(
        scheduleOptions,
        null
      )

      if (this._references.refDialogSchedule.current) {
        this._references.refDialogSchedule.current.show(
          true,
          null,
          previousSchedulePeriods
        )
      }
    }
  }

  _onClickSetting (scheduleOption) {
    this.data.scheduleOption = scheduleOption
    let totalHours = 0
    if (scheduleOption.schedules && scheduleOption.schedules.length > 0) {
      scheduleOption.schedules.forEach(item => {
        totalHours += item.timeTaken || 0
      })

      totalHours = parseFloat(totalHours / 2 / 60)
    }

    const fromDate = scheduleOption.fromDate
      ? this._convertSettingDisplayDate(scheduleOption.fromDate)
      : null
    const expireMsg = scheduleOption.toDate
      ? `${IntlUtil.convertMessage(
          'user.schedule.itemExpiresOn'
        )} ${this._convertSettingDisplayDate(scheduleOption.toDate)}`
      : null

    this._setFABButtonVisible(false)

    if (this._references.scheduleSettingDialog.current) {
      this._references.scheduleSettingDialog.current.show(
        fromDate,
        expireMsg,
        null,
        totalHours
      )
    }

    this.setState({ dataDate: new Date() })
  }

  _convertSettingDisplayDate (convertDate) {
    const date = convertDate ? new Date(convertDate) : null

    if (date) {
      const shortMonth = [
        'planner.planner.monthJanuary',
        'planner.planner.monthFebruary',
        'planner.planner.monthMarch',
        'planner.planner.monthApril',
        'planner.planner.monthMay',
        'planner.planner.monthJune',
        'planner.planner.monthJuly',
        'planner.planner.monthAugust',
        'planner.planner.monthSeptember',
        'planner.planner.monthOctober',
        'planner.planner.monthNovember',
        'planner.planner.monthDecember'
      ]

      const monthLabel = shortMonth[date.getMonth()]
        ? IntlUtil.convertMessage(shortMonth[date.getMonth()])
        : ''

      return `${date.getDate()} ${monthLabel} ${date.getFullYear()}`
    }

    return ''
  }

  _onClickEditSchedule (scheduleOption, e) {
    e.preventDefault()

    if (this._references.scheduleSettingDialog.current) {
      this._references.scheduleSettingDialog.current.hide()
    }

    if (scheduleOption && scheduleOption.id && this.data.curUser) {
      const schedule = ScheduleOptionUtil.getRenderScheduleObject(
        scheduleOption
      )
      const previousSchedulePeriods = ScheduleOptionUtil.getAllSchedulePeriods(
        this.data.curUser.scheduleOptions,
        schedule.id
      )

      this._setFABButtonVisible(false)

      if (this._references.refDialogSchedule.current) {
        this._references.refDialogSchedule.current.show(
          false,
          schedule,
          previousSchedulePeriods
        )
      }
    }
  }

  _onClickDeleteSchedule (e) {
    e.preventDefault()

    if (this._references.scheduleConfirmDelete.current) {
      this._references.scheduleConfirmDelete.current.show()
    }
  }

  _onClickScheduleDeleteConfirm (e) {
    e.preventDefault()

    const scheduleOption = this.data.scheduleOption
    if (!scheduleOption.id) {
      return false
    }

    if (this.data.curUser) {
      if (scheduleOption.id && scheduleOption.id.indexOf('schedule-') !== 0) {
        this.data.curUser.removeScheduleIds.push(scheduleOption.id)
      }

      _.remove(
        this.data.curUser.scheduleOptions,
        obj => obj.id === scheduleOption.id
      )

      if (this._references.scheduleSettingDialog.current) {
        this._references.scheduleSettingDialog.current.hide()
      }

      if (this._references.userform.current) {
        this._references.userform.current.refreshSchedules(
          this.data.curUser.scheduleOptions
        )
      }
    }
  }

  _getTeamDefaultLanguage () {
    const defaultCountry = 'NL'
    const currCountry = _.get(app.getTeam(), 'profile.country', defaultCountry)

    let language = 'NL'
    if (currCountry === 'UK') {
      language = 'EN'
    } else if (currCountry === 'DE') {
      language = 'DE'
    } else if (currCountry === 'US') {
      language = 'US'
    }

    return language
  }

  _getTimezone (country) {
    if (country === 'DE') {
      return 'Europe/Berlin'
    } else if (country === 'UK') {
      return 'Europe/London'
    } else if (country === 'US') {
      return 'America/New_York'
    }

    return 'Europe/Amsterdam'
  }

  /* Realtime Events */
  _initEvents () {
    this._eventHandlers.userCreated = this._eventReload.bind(
      this,
      'User',
      'Created'
    )
    this._eventHandlers.userUpdated = this._eventReload.bind(
      this,
      'User',
      'Updated'
    )
    this._eventHandlers.userRemoved = this._eventReload.bind(
      this,
      'User',
      'Removed'
    )
    this._eventHandlers.userPatched = this._eventReload.bind(
      this,
      'User',
      'Patched'
    )

    const userService = app.service('/api/users/team')
    userService.on('created', this._eventHandlers.userCreated)
    userService.on('updated', this._eventHandlers.userUpdated)
    userService.on('removed', this._eventHandlers.userRemoved)
    userService.on('patched', this._eventHandlers.userPatched)
  }

  _releaseEvents () {
    const userService = app.service('/api/users/team')
    userService.off('created', this._eventHandlers.userCreated)
    userService.off('updated', this._eventHandlers.userUpdated)
    userService.off('removed', this._eventHandlers.userRemoved)
    userService.off('patched', this._eventHandlers.userPatched)

    this._eventHandlers.userService = null
    this._eventHandlers.userService = null
    this._eventHandlers.userService = null
    this._eventHandlers.userService = null
  }

  _eventReload (_objectName, _eventName, _eventData) {
    this._reloadData()
  }

  /* Header Functions - START */
  _onHeaderGridListToggle (isGridActive) {
    this.state.type = isGridActive ? 'grid' : 'list'
    this.setState({ dataDate: new Date() })
  }

  _onHeaderContentFilter (option) {
    if (!this.data.filter) {
      this.data.filter = {}
    }

    this.data.filter.filterType =
      option.ident === 'active' ? 'archieve' : 'active'
    this.data.pageNo = 1

    this._reloadData()
  }

  /* Header Functions - END */
}

export default PageUser
